import { Box, Button, Grid } from '@material-ui/core';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { TransitionProps } from '@mui/material/transitions';
import axios from "axios";
import React, { useEffect, useState } from 'react';
import { useFieldArray, useForm } from 'react-hook-form';
import { Link, useLocation } from 'react-router-dom';
import { API_URL } from "../../Const";
import ServerlessDeleteButton from '../utilComponent/ServerlessDeleteButton';
import GenericTemplate from "../templates/GenericTemplate";
import Typography from '@mui/material/Typography';
import { useLoadingOverlay } from '../../utilHooks/loadingOverlay';




/* ダイアログ関連*/
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
/*ダイアログ関連*/

const ConstructionCreat: React.FC = () => {
  const {openLoading, closeLoading} = useLoadingOverlay()

  /*スピナー処理*/
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  /*スピナー処理*/

  const [errorMessageOfCreates, setErrorMessageOfCreates] = useState<string[]>([])

  /*ダイアログ処理*/
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [erAppendOpen, setErAppendOpen] = React.useState(false);
  const handleClickErAppendOpen = () => {
    setErAppendOpen(true);
  };
  const handleErAppendClose = () => {
    setErAppendOpen(false);
  };
  /*ダイアログ処理*/

  /*ターゲット*/
  const [set_checklist_name, setChecklist_name] = useState();
  const [set_checklist_memo, setChecklist_memo] = useState();
  const [set_created_by, setCreated_by] = useState();
  const [set_updated_by, setUpdated_by] = useState();

  const change_checklist_name = (e: any) => {
    setChecklist_name(e.target.value);
  }
  const change_checklist_memo = (e: any) => {
    setChecklist_memo(e.target.value);
  }

  const onClickAppend = () => {
    if(fields.length >= 15) {
      handleClickErAppendOpen();
      return
    }

    append({})
  }

  const onSubmit = (submitData: { bleach: Charactor[] }, e: any) => {
    const validErrorMessages : string[] = []
    if(!set_checklist_name) {
      validErrorMessages.push('チェックリスト名が空です')
    }
    if(submitData.bleach.length < 1) {
      validErrorMessages.push('チェックリストは1件以上登録して下さい。')
    }

    setErrorMessageOfCreates(validErrorMessages)
    if(validErrorMessages.length >= 1) {
      return
    }

    /*追加削除*/
    //console.log(submitData.bleach);
    setCharactor(submitData.bleach);
    /*追加削除*/

    /*スピナー*/
    if (!loading) {
      setSuccess(false);
      setLoading(true);
    }
    /*スピナー*/

    let checklist_name_pos;
    let checklist_memo_pos;
    let created_by_pos;
    let updated_by_pos;

    if (set_checklist_name === undefined) {
      checklist_name_pos = checklist_name;
    } else {
      checklist_name_pos = set_checklist_name;
    }

    if (set_checklist_memo === undefined) {
      checklist_memo_pos = checklist_memo;
    } else {
      checklist_memo_pos = set_checklist_memo;
    }

    if (set_created_by === undefined) {
      created_by_pos = created_by;
    } else {
      created_by_pos = set_created_by;
    }

    if (set_updated_by === undefined) {
      updated_by_pos = updated_by;
    } else {
      updated_by_pos = set_updated_by;
    }

    //console.log(checklist_name_pos)
    //console.log(checklist_memo_pos)
    //console.log(created_by_pos)
    //console.log(updated_by_pos)

    // POST処理

    openLoading()
    axios.post(API_URL.CHECKLIST_UPDATE,
      {
        "company_id": jsonlist.user.company_id,
        "checklist_group_id": check_id,
        "checklist_name": checklist_name_pos,
        "checklist_memo": checklist_memo_pos,
        "login_user": jsonlist.user.user_id,
        "list": submitData.bleach
      },
      { headers: { Authorization: jsonlist.token.IdToken } },
    )
      .then(res => {
        setSuccess(true);
        setLoading(false);
        handleClickOpen();
        console.log(res)
      })
      .catch(error => {
        setSuccess(true);
        setLoading(false);
        console.log(error)
      })
      .finally(() => {
        closeLoading()
      })

    /*POST用パラメータ*/

  }
  /*ターゲット*/

  /*id取得*/
  const { state } = useLocation();
  const check_id = (state as any)?.check_id;
  const check_lists = (state as any)?.lists;
  /*id取得*/


  /*追加削除*/

  type Charactor = {
    checklist_id: number;
    item_name: string;
  };

  /*追加削除*/

  let jsonlist = JSON.parse(localStorage.getItem("datalist") || '{}')
  //console.log(jsonlist.token.IdToken)

  const [posts, setPosts] = useState<any[]>([])
  useEffect(() => {
    openLoading()
    axios.post(API_URL.CHECKLIST_GET,
      {
        "company_id": jsonlist.user.company_id,
        "checklist_group_id": check_id
      },
      { headers: { Authorization: jsonlist.token.IdToken } },
    )
      .then(res => {
        const checks = res.data.data;
        //console.log(checks)
        setPosts(checks)
        setChecklist_name(checks.checklist_name)
        setChecklist_memo(checks.checklist_memo)
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        closeLoading()
      })
  }, []);

  const checklist_name = (posts as any)?.checklist_name;
  const checklist_memo = (posts as any)?.checklist_memo;
  const created_by = (posts as any)?.created_by;
  const updated_by = (posts as any)?.updated_by;


  /*追加削除*/
  const [charactor, setCharactor] = useState<Charactor[]>([]);
  const {
    handleSubmit, control, register, reset,
  } = useForm({});

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'bleach',
  });

  useEffect(() => {
    reset({
      bleach: check_lists,
    });
  }, [reset]);
  /*追加削除*/

  return (

    <GenericTemplate title="チェックリスト名">
      <div>
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle style={{ color: "#0d47a1" }}>{"更新が完了しました"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              style={{ color: "#fff", backgroundColor: "#1e88e5" }}
              component={Link}
              to="/Checklist"
            >OK</Button>
          </DialogActions>
        </Dialog>
      </div>

      <div>
        <Dialog
          open={erAppendOpen}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleErAppendClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle style={{ color: "#0d47a1" }}>{"チェック項目の登録は15件までです。"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              style={{ color: "#fff", backgroundColor: "#1e88e5" }}
              onClick={() => handleErAppendClose()}
            >閉じる</Button>
          </DialogActions>
        </Dialog>
      </div>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={3} margin={2}></Stack>
        <Stack spacing={3} margin={2}>
          <Grid container spacing={0} justifyContent="center">
            <Grid item xs={2}>チェックリスト名</Grid>
            <Grid item xs={10}>
              <TextField
                id="outlined-basic"
                variant="outlined"
                className="InsText3"
                multiline={true}
                defaultValue={checklist_name}
                onChange={change_checklist_name}
              />
            </Grid>
          </Grid>
        </Stack>

        <Stack spacing={3} margin={2}>
          <Grid container spacing={0} justifyContent="center">
            <Grid item xs={2}>概要</Grid>
            <Grid item xs={10}>
              <TextField
                id="outlined-basic"
                variant="outlined"
                className="InsText3"
                multiline={true}
                rows={2}
                defaultValue={checklist_memo}
                onChange={change_checklist_memo}
              />
            </Grid>
          </Grid>
        </Stack>
        <Stack spacing={3} margin={2}></Stack>
        <Button
          color="primary"
          variant="contained"
          size="large"
          onClick={onClickAppend}
        >
          ＋　チェック項目追加
        </Button>
        <Stack margin={1}></Stack>
        <div className="textBoxCheck">
          <section>
            <table>
              <tbody>
                {fields.map((field, index) => (
                  <tr key={index}>
                    <td
                      style={{ width: "10%", fontSize: "19px" }}
                    >
                      {index + 1}
                    </td>
                    <td
                      style={{ width: "70%" }}
                    >
                      <input type="hidden" {...register(`bleach[${index}].checklist_id`)} value={index} />
                      <TextField
                        id="outlined-basic"
                        variant="outlined"
                        className="InsText"
                        multiline={true}
                        {...register(`bleach[${index}].item_name`, { required: true })}
                      />
                    </td>

                    <td
                      style={{ width: "100px" }}
                    >

                      <ServerlessDeleteButton onClick={() => remove(index)}/>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>
        </div>

        <Stack spacing={3} margin={2}></Stack>
        <Stack spacing={1} margin={1}>
        {errorMessageOfCreates.map(message => (
          <Grid item xs={6}>
            <Typography variant="subtitle1" component="div" color="red">
              {message}
            </Typography>
          </Grid>
        ))}
        </Stack>
        <Stack spacing={0} margin={0}>
          <Grid container spacing={0}>
            <Grid item xs={2}>

              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ m: 1, position: 'relative' }}>
                  <Button
                    color="primary"
                    variant="contained"
                    disabled={loading}
                    size="large"
                    type="submit"
                  >
                    更新
                  </Button>
                  {loading && (
                    <CircularProgress
                      size={24}
                      sx={{
                        color: green[500],
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        marginTop: '-12px',
                        marginLeft: '-12px',
                      }}
                    />
                  )}
                </Box>
              </Box>

            </Grid>
            <Grid item xs={2}>

              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ m: 1, position: 'relative' }}>
                  <Button
                    className="btnlink"
                    color="primary"
                    variant="contained"
                    size="large"
                    component={Link}
                    to="/Checklist"
                  >
                    キャンセル
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Stack>
      </form>




    </GenericTemplate>
  );
};

export default ConstructionCreat;